import type { PlanStrategyType } from '../types';

export const strategyMeta: Record<PlanStrategyType, { title: string }> = {
  NAIVE: { title: 'Naive plan' },
  RTB: { title: 'WEB plan' },
  OOH: { title: 'OOH plan' },
  RADIO: { title: 'RADIO plan' },
  PRESS: { title: 'Press plan' },
};
